import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ question, conversationId }) =>
    present(
      repository
        .submitChatJob(question, conversationId)
        .catch((error) => Promise.reject({ question, conversationId, error })),
    );
}

export type { Interactor };

export { createInteractor };
